import { render, staticRenderFns } from "./Analyzes.vue?vue&type=template&id=08668b08&scoped=true&"
import script from "./Analyzes.vue?vue&type=script&lang=tsx&"
export * from "./Analyzes.vue?vue&type=script&lang=tsx&"
import style0 from "./Analyzes.vue?vue&type=style&index=0&id=08668b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08668b08",
  null
  
)

export default component.exports